module.exports = __webpack_public_path__ + "static/brain-chart.dfd2af1d.jpg";